var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenLeaf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qrebto2zza",
    d: "M0 0h16.922v19.34H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz9jvtplyc",
    d: "M0 0h16.922v19.34H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 2.017 25.63)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mgi6erubjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qrebto2zza"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.304 7.438c-3.98 3.346-7.536 6.512-8.531 11.901C6.64 16.641 11.757 16 14.468 12.737 17.267 9.37 16.77 4.713 16.922 0c-3.256 1.547-6.48 2.403-9.78 3.162-6.314 1.451-8.986 8.323-5.783 14.71 3.548-6.417 6.123-9.21 9.945-10.434z",
    fill: "#0E4816",
    fillRule: "nonzero",
    mask: "url(#mgi6erubjb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.204)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yotboafakd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bz9jvtplyc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.304 7.438c-3.98 3.346-7.536 6.512-8.531 11.901C6.64 16.641 11.757 16 14.468 12.737 17.267 9.37 16.77 4.713 16.922 0c-3.256 1.547-6.48 2.403-9.78 3.162-6.314 1.451-8.986 8.323-5.783 14.71 3.548-6.417 6.123-9.21 9.945-10.434z",
    fill: "#589D62",
    fillRule: "nonzero",
    mask: "url(#yotboafakd)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLeaf);
export default __webpack_public_path__ + "static/media/green-leaf.61add0d2a1a5f9f991449ac9fd49d1e3.svg";
export { ForwardRef as ReactComponent };